import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function ConfirmModal({
    show,
    handleHide,
    handleConfirm
}) {
  return (
    <Modal show={show} onHide={handleHide}>
        <Modal.Header closeButton>
        <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you really want to do it?</Modal.Body>
        <Modal.Footer>
        <Button variant="danger" onClick={handleHide}>
            No
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
            Yes
        </Button>
        </Modal.Footer>
    </Modal>
  )
}
